import { RoomContextType, RoomContext } from '@/RoomContext'
import useRoomActions from '@/services/useRoomActions'
import { MIDIInput } from '@/types/WebMidi'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { SidebarTooltip as Tooltip } from '@/pages/SessionPage/internal/sidebar/SidebarTooltip'
import { Button } from '@/UIComponents2/Button'
import MicrophoneOffIcon from '@/CustomIcons/MicrophoneOffIcon'
import MicrophoneIcon from '@/CustomIcons/MicrophoneIcon'
import GearIcon from '@/CustomIcons/GearIcon'
import { cn } from '@/utlis/cn'
import { MidiMeter, PeerMidiMeter } from '@/components/MidiMeter2'
import { MuseMidiDeviceInfo } from '@/services/MusePeer'
import { MusePeer } from '@/services/RoomContextMusePeer'
import { sessionSettingsTrigger } from '@/pages/SessionPage/SessionPage'

type MidiControlsProps =
    | {
          user: 'me'
          device: MIDIInput
      }
    | {
          user: MusePeer
          device: MuseMidiDeviceInfo
      }
export function MidiControls(props: MidiControlsProps) {
    const { t } = useTranslation()
    const { state: roomState } = useContext(RoomContext) as RoomContextType
    const { toggleMyMidiDeviceMute, toggleRemoteMidiMute } = useRoomActions()

    const isMuted =
        props.user === 'me'
            ? roomState.myMidiMuteState[props.device.id] || false
            : (props.user.remoteMidiContolStates[props.device.sourceId]?.isMuted ?? false)

    const isMutedByOwner = props.user === 'me' ? false : (props.device?.isMuted ?? false)

    const labelTooltip =
        props.user === 'me' ? null : isMutedByOwner ? t('Muted by the owner of this device') : t('Receiving MIDI')

    function handleToggleMute() {
        if (props.user === 'me') {
            toggleMyMidiDeviceMute(props.device.id)
        } else {
            toggleRemoteMidiMute(props.user, props.device.sourceId ?? '')
        }
    }

    return (
        <div className="w-full flex justify-between items-center">
            <div className="w-[65%] flex gap-[8px] items-center">
                {props.user === 'me' ? (
                    <MidiMeter midiInput={props.device} className="py-0 h-[30px] rounded-[10px]" />
                ) : (
                    <PeerMidiMeter peerMidiDevice={props.device} className="py-0 h-[30px] rounded-[10px]" />
                )}
                <Tooltip variant="info" text={labelTooltip}>
                    <div className="truncate">{props.user === 'me' ? props.device.name : props.device.label}</div>
                </Tooltip>
            </div>
            <div className="flex gap-[16px]">
                <Button
                    variant="tertiary"
                    minimal
                    className={cn(
                        'flex flex-col gap-[2px] items-center h-[30px] w-[30px] rounded-[10px]',
                        !!isMuted ? 'text-muse-danger' : 'text-muse-fg'
                    )}
                    onClick={handleToggleMute}
                >
                    {!!isMuted ? (
                        <MicrophoneOffIcon style={{ fontSize: '1.25rem' }} />
                    ) : (
                        <MicrophoneIcon style={{ fontSize: '1.25rem' }} />
                    )}
                </Button>
                <Button
                    variant="basic"
                    onClick={() => {
                        sessionSettingsTrigger.trigger({ tab: 'midi' })
                    }}
                >
                    <GearIcon className="-mt-1" style={{ fontSize: '1.3rem' }} />
                </Button>
            </div>
        </div>
    )
}
